import KendoMediaPlayer from './KendoMediaPlayer'
import KendoMediaPlayerInstaller from './kendo-mediaplayer-installer'

export { KendoMediaPlayer, KendoMediaPlayer as MediaPlayer, KendoMediaPlayerInstaller, KendoMediaPlayerInstaller as MediaPlayerInstaller }


// WEBPACK FOOTER //
// ./packages/kendo-mediaplayer-vue-wrapper/src/index.js